import { render, staticRenderFns } from "./CreateAssignmentAnswer.vue?vue&type=template&id=11073be1"
import script from "@/services/assignment/answer/create-assignment-answer.js?vue&type=script&lang=js&external"
export * from "@/services/assignment/answer/create-assignment-answer.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/assignment/common-assignment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports